<template>
    <div class="tab-pane" id="admission_detail_deo_tab" aria-labelledby="admission-detail-deo-tab">
        <div class="form-group row">
            <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                <label for="name" class="form-label">School:<span class="text-danger">*</span></label>
                <select v-model="school_id" class="form-control" aria-label="school_id" :class="{ 'is-invalid': is_invalid }" id="school_id" @change="getAdmittedList(),remove_err('school_id')">
                    <option v-for="(item, i) in schools" :key="i" :value="item.id">{{item.organization}}</option>
                </select>
                <span v-if="is_invalid">{{error}}</span>
            </div>
        </div>
        <div v-show="showTable" class="card">
            <label class="card-header text-center"><strong>The Schools Placement Details</strong></label>
            <table class="table table-bordered table-striped" id="OrgDetails">
                <thead>
                    <tr>
                        <th></th>
                        <th colspan="4" class="text-center">Student Information</th>
                        <th colspan="5" class="text-center">Student Placement</th>
                    </tr>
                    <tr>
                        <th>S.No</th>
                        <th>Name of Student</th>
                        <th>Index Number</th>
                        <th>Dzongkhag</th>
                        <th>School</th>
                        <th>Dzongkhag</th>
                        <th>School</th>
                        <th>Class</th>
                        <th>Stream</th>
                        <th>Remarks</th>

                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item,index) in admission_details" :key="index">
                        <td>{{index + 1}}</td>
                        <td>{{item.name}}</td>
                        <td>{{item.std_indexno}}</td>
                        <td>{{item.dzongkhag}}</td>
                        <td>{{item.organization}}</td>
                        <td>{{item.placement_dzo}}</td>
                        <td>{{item.placement_org}}</td>
                        <td>{{item.class}}</td>
                        <td>{{item.stream}}</td>
                        <td>{{item.remarks}}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>
<script>
export default {
    data(){
        return {
            showTable:false,
            dzongkhags:[],
            dzongkhag_id:'',
            schools:[],
            school_id:'',
            user_type:'',
            type:'admitted',
            admission_details:[],
            is_invalid:false,
            error:''
        }
    },
    methods:{
        remove_err(fieldid){
            if($('#'+fieldid).val()!=""){
                $('#'+fieldid).removeClass('is-invalid');
                this.showTable=true;
            }else{
                this.is_invalid = true;
                this.error = "This field is required"
            }
        },
        getAdmittedList(){
            axios.get('admissions/getAdmittedList/'+this.dzongkhag_id+'/'+this.type+'/'+this.school_id).then(res =>{
                let data = res.data;
                this.admission_details = data
            }).catch(error => console.log(error));
        },
        getOrganization(dzongkhag_id){
            this.schools = [];
            axios.get('school/getPublicOrganization/'+dzongkhag_id)
            .then(response =>{ this.schools = response.data })
            .catch(error => console.log(error));
        },
    },
    mounted(){
        axios.get('getSessionDetail')
        .then(response => {
            let data = response.data.data;
            this.user_type=data['role'];
            this.dzongkhag_id = data['dzongkhag_id'];
            this.getAdmittedList()
            this.getOrganization(data['dzongkhag_id'])
        })
    }
    
}
</script>